module.exports = __webpack_public_path__ + "static/media/image_icon_inactive.f69899da.svg";